// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__38F8j","list":"styles_list__3cO6s"};